module.exports = __webpack_public_path__ + "img/zhongxin.edb35c38.png";